import { StateCreator } from "zustand";
import { ModalSliceProps } from "../lib/type";

export const modalBaseSlice: StateCreator<ModalSliceProps> = (set, get, api) => ({
    isOpen: false,
    close: () => set(() => ({ isOpen: false })),
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    open: () => set(() => ({ isOpen: true })),
    reset: () => set(() => ({ ...api.getInitialState() }))
});
